import { render, staticRenderFns } from "./oss-investigation.vue?vue&type=template&id=5cdf418c&scoped=true&"
import script from "./oss-investigation.vue?vue&type=script&lang=js&"
export * from "./oss-investigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdf418c",
  null
  
)

export default component.exports